import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#000000',
      black: '#000000',
      white: '#FFFFFF'
    },
    secondary: {
      main: '#FFF2E9',
      helpscout: '#FFEADF',
      gorgias: {
        DEFAULT: '#FFF0DF',
        light: '#FFFBF0'
      },
      peach: '#FFF0DF',
      peachDark: '#FD9783',
      darkMintGreen: '#98BEAA',
      brightBrown: '#752801',
      gorgiasAlt: '#FFEADF',
      lightPeach: {
        DEFAULT: '#FFFBEE',
        alt: '#CBEEDC'
      },
      lightMintGreen: '#CBEEDC',
      lightBrown: '#8B7263',
      rustyRed: "#D02832",
      rustyRedLight: "rgba(208, 40, 50, 0.1)",
      interactionFocus: '#B5E0CA',
      lightAquamarine: '#E4FEFD'
    },
    
    neutral: {
      DEFAULT: '#787878',
      dark1: '#9F9F9F',
      dark2: '#A6A6A6',
      dark3: '#C2C2C2',
      light1: '#D9D9D9',
      light2: '#DBDBDB',
      light3: '#DCDCDC',
      light4: '#EFEFEF',
      light5: '#D9D9D9'
    }
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            borderColor: '#000000',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none'
            },
            '&.MuiButton-contained.Mui-disabled': {
              backgroundColor: ownerState.sx?.backgroundColor,
              color: ownerState.sx?.color,
              opacity:
                ownerState.sx?.backgroundColor === 'black' ||
                  ownerState.sx?.backgroundColor === '#000' ||
                  ownerState.sx?.backgroundColor === '#000000'
                  ? 0.5
                  : 0.4,
              cursor: 'not-allowed !important'
            }
          };
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          paddingLeft: '4px',
          paddingRight: '4px'
        }
      }
    }
  },

  breakpoints: {
    values: {
      xxs: 0,
      xs: 480,
      sm: 575,
      smd: 640,
      md: 768,
      base: 992,
      lg: 1024,
      xl: 1280,
      xxl: 1440,
      xxxl: 1536
    }
  }
});
